import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_11 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Customer' : 'Add Customer',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Phone Number", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.phone_number) = $event)),
                placeholder: "Enter phone number",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.phone_number]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                placeholder: "Enter name"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                placeholder: "Enter email"
              }, null, 512), [
                [_vModelText, _ctx.form.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Asal Kampus / Universitas", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.university) = $event)),
                placeholder: "Enter university"
              }, null, 512), [
                [_vModelText, _ctx.form.university]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Jurusan / Program Studi", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.major) = $event)),
                placeholder: "Enter major"
              }, null, 512), [
                [_vModelText, _ctx.form.major]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Free Tokens", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.free_tokens) = $event)),
                placeholder: "0",
                min: "0"
              }, null, 512), [
                [_vModelText, _ctx.form.free_tokens]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: "/customers",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Customer' : 'Create Customer'), 1)
            ], 8, _hoisted_12)
          ])
        ], 32)
      ])
    ])
  ]))
}